import { render, staticRenderFns } from "./courseTypeModal.vue?vue&type=template&id=0454baba&"
import script from "./courseTypeModal.vue?vue&type=script&lang=js&"
export * from "./courseTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports